import React, { useState } from 'react';
import { Mail, CheckCircle } from 'lucide-react';
import api from '../../services/api';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsLoading(true);
    
    try {
      const response = await api.post('/newsletter/subscribe', { email });
      
      if (response.data.success) {
        setIsSubscribed(true);
        setEmail('');
        console.log('✅ Newsletter aboneliği başarılı');
      } else {
        alert(response.data.message || 'Bir hata oluştu');
      }
    } catch (error) {
      console.error('❌ Newsletter abonelik hatası:', error);
      alert('Abonelik sırasında bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-lg p-8 my-12">
      <div className="max-w-4xl mx-auto text-center">
        <div className="flex items-center justify-center mb-4">
          <div className="bg-white rounded-lg p-3 mr-4">
            <Mail className="h-6 w-6 text-orange-500" />
          </div>
          <h3 className="text-2xl font-bold text-white">
            Özel Fırsatları Kaçırmayın!
          </h3>
        </div>
        <p className="text-orange-100 mb-6 text-lg">
          E-bültenimize abone olun ve özel indirimlerden haberdar olun
        </p>
        {isSubscribed ? (
          <div className="flex items-center justify-center space-x-2 text-white">
            <CheckCircle className="h-6 w-6 text-green-300" />
            <span className="text-lg font-medium">Başarıyla abone oldunuz!</span>
          </div>
        ) : (
          <form onSubmit={handleNewsletterSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-posta adresiniz"
              required
              className="flex-1 px-4 py-3 rounded-lg border-0 focus:ring-2 focus:ring-white focus:outline-none"
            />
            <button 
              type="submit"
              disabled={isLoading}
              className="bg-white text-orange-600 px-6 py-3 rounded-lg font-semibold hover:bg-orange-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
            >
              {isLoading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-orange-600 mr-2"></div>
                  Abone Olunuyor...
                </>
              ) : (
                'Abone Ol'
              )}
            </button>
          </form>
        )}
        <div className="flex flex-col sm:flex-row justify-center items-center mt-6 space-y-2 sm:space-y-0 sm:space-x-8 text-orange-100">
          <div className="flex items-center">
            <div className="w-2 h-2 bg-orange-300 rounded-full mr-2"></div>
            <span>Özel İndirimler</span>
          </div>
          <div className="flex items-center">
            <div className="w-2 h-2 bg-orange-300 rounded-full mr-2"></div>
            <span>İlk Haberler</span>
          </div>
          <div className="flex items-center">
            <div className="w-2 h-2 bg-orange-300 rounded-full mr-2"></div>
            <span>Ücretsiz Kargo</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
